import React from 'react';

import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { Select } from '@nhl/nhl-breakaway-ui';

import { filterActionCreators } from '~/redux/ducks/playersAndTeams/filter';
import { commonMessages } from '~/utility/commonMessages';

const HandDominanceSelect = () => {
    const dispatch = useDispatch();
    const intl = useIntl();

    const setHand = (e, { value }) => {
        dispatch(filterActionCreators.setDominantHand(value));
    };

    const reportCategory = useSelector((state) => state.playersAndTeams.report.reportCategory);
    const selectedHand = useSelector((state) => state.playersAndTeams.filter.values.shootsCatches);

    const options = [
        { value: '', label: 'Both', key: 'both' },
        { value: 'L', label: 'Left', key: 'l' },
        { value: 'R', label: 'Right', key: 'r' },
    ].map((obj) => ({
        ...obj,
        label: intl.formatMessage(
            commonMessages.handDominanceValues[`${reportCategory === 'goalie' ? 'goalie' : 'skater'}${obj.label}`],
        ),
    }));
    const value = options.find((obj) => obj.value === selectedHand);

    return (
        <Select
            onOptionChange={setHand}
            options={options}
            selectedOption={value}
            isSearchEnabled
            optionsBoxAriaLabel=""
            dropdownButtonAriaLabel=""
        />
    );
};

export default React.memo(HandDominanceSelect);
